import React, { useState, useEffect } from 'react';

import { connect } from 'react-redux';

import { debounce, isEmpty } from 'lodash';

import SensorTypeTable from './SensorTypeTable';
import EquipmentTypeTable from './EquipmentTypeTable';
import LookupViewSelector from '../../../components/LookupViewSelector';
import EquipmentTypeTableActionMenu from './EquipmentTypeTableActionMenu';
import SensorTypeTableActionMenu from './SensorTypeTableActionMenu';
import CreateEquipmentTypeModal from '../Modals/CreateEquipmentTypeModal';
import CreateSensorTypeModal from '../Modals/CreateSensorTypeModal';
import SearchInput from '../../Global/SearchInput';

import * as classes from './TableContainer.module.css';
import LookupTotals from '../../../components/LookupTotals';
import { setPageTitle } from '../../../helpers/auth';

const TableContainer = ({
    activeNavCompany,
    equipmentTypes,
    sensorTypes,
    ...props
}) => {
    const [activeTab, setActiveTab] = useState('Sensor Types');
    const [equipmentSearchTerm, setEquipmentSearchTerm] = useState('');
    const [sensorSearchTerm, setSensorSearchTerm] = useState('');
    const [createEquipmentTypeModalOpen, setCreateEquipmentTypeModalOpen] = useState(false);
    const [createSensorTypeModalOpen, setCreateSensorTypeModalOpen] = useState(false);
    const [refreshTab, setRefreshTab] = useState('');

    useEffect(() => {
        if (!isEmpty(activeNavCompany)) {
            setPageTitle(activeNavCompany.name, activeTab);
        } else {
            setPageTitle('Dashboard', activeTab);
        }
    }, [activeNavCompany, activeTab]);

    const handleSearch = async searchTerm => {
        if (activeTab === 'Equipment Types') {
            setEquipmentSearchTerm(searchTerm);
        } else {
            setSensorSearchTerm(searchTerm);
        }
    };

    const refreshGrid = () => {
        setRefreshTab(activeTab);
    };

    return (
        <div className={classes.TableContainer}>
            <div className={classes.TableContainerHead}>
                <div className={classes.SelectContainer}>
                    <LookupViewSelector
                        view={activeTab}
                        handleChangeView={setActiveTab}
                    />
                </div>
                <div className={classes.SearchContainer}>
                    <SearchInput
                        key={new Date()}
                        className={classes.SearchInput}
                        search={debounce(handleSearch, 700)}
                        placeholder={`Search by ${activeTab === 'Equipment Types' ? 'Equipment Type' : 'Sensor Type'}`}
                        value={activeTab === 'Equipment Types' ? equipmentSearchTerm : sensorSearchTerm}
                    />
                </div>
                <div className={classes.TotalsContainer}>
                    <LookupTotals
                        title={activeTab}
                        value={activeTab === 'Equipment Types' ? equipmentTypes.length : sensorTypes.length}
                    />
                </div>
                <div
                    className={classes.RefreshContainer}
                    aria-hidden="true"
                    role="button"
                    tabIndex={0}
                    onClick={refreshGrid}
                >
                    <span className="material-icons-outlined">refresh</span>
                </div>
                <div className={classes.ActionButtonContainer}>
                    {
                        activeTab === 'Equipment Types' ?
                            <EquipmentTypeTableActionMenu
                                setCreateEquipmentTypeModalOpen={setCreateEquipmentTypeModalOpen}
                            />
                            :
                            <SensorTypeTableActionMenu
                                setCreateSensorTypeModalOpen={setCreateSensorTypeModalOpen}
                            />
                    }
                </div>
            </div>
            <div className={classes.GridContainer}>
                {
                    activeTab === 'Equipment Types' ?
                        <EquipmentTypeTable
                            searchTerm={equipmentSearchTerm}
                            refreshTab={refreshTab}
                            setRefreshTab={() => setRefreshTab('')}
                        />
                        :
                        null
                }
                {
                    activeTab === 'Sensor Types' ?
                        <SensorTypeTable
                            searchTerm={sensorSearchTerm}
                            refreshTab={refreshTab}
                            setRefreshTab={() => setRefreshTab('')}
                        />
                        :
                        null
                }
            </div>
            {
                createEquipmentTypeModalOpen ?
                    <CreateEquipmentTypeModal
                        setCreateEquipmentTypeModalOpen={setCreateEquipmentTypeModalOpen}
                    />
                    :
                    null
            }
            {
                createSensorTypeModalOpen ?
                    <CreateSensorTypeModal
                        setCreateSensorTypeModalOpen={setCreateSensorTypeModalOpen}
                    />
                    :
                    null
            }
        </div>
    );
};

const mapStateToProps = state => ({
    activeNavCompany: state.bob.activeNavCompany,
    equipmentTypes:   state.lookup.equipmentTypes,
    sensorTypes:      state.lookup.sensorTypes
});

export default connect(mapStateToProps, null)(TableContainer);
